import React from 'react';
import classnames from 'classnames';
import classes from './increment-note.scss';
const IncrementNote = ({
  className = '',
  quantIncrement = 1,
  minQuant,
  isLimitedEdition = false
}) => {
  if (quantIncrement === 1) {
    return null;
  }
  const min = minQuant || quantIncrement;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, className)
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.icon, {
      [classes.orangeIcon]: isLimitedEdition
    })
  }), /*#__PURE__*/React.createElement("p", {
    "data-text": "QuantityIncrement"
  }, "Has to be ordered in increments of ", quantIncrement, ", for example, ", min, ",", ' ', min + quantIncrement, ", ", min + quantIncrement * 2, ", etc."));
};
export default IncrementNote;